import { createApp } from 'vue'
import App from './App.vue'
import router from '@/router'
import '@/assets/css/global.less'
import '@/assets/css/animate.less'
// import { installAntDesign } from '@/vendors/ant-design'
import { installIcon } from '@/vendors/my-icon'
import { installIcon2023 } from '@/vendors/my-icon-2023'
import { installSentry } from './vendors/sentry'
// import '@/vendors/vconsole'
import i18n from '@/vendors/i18n'
const app = createApp(App)
// installAntDesign(app)
installIcon(app)
installIcon2023(app)
installSentry(app)
app.use(router).use(i18n).mount('#app')
